import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import CadastrarProtetico from '../../components/Protetico/CadastrarProtetico'

const mapStateToProps = (store) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CadastrarProtetico)
